// extracted by mini-css-extract-plugin
export default {"rating":"kK-z","numberOfStars":"lK-z","count":"mK-z","barGraphSpacing":"nK-z","barGraph":"oK-z"};